import { FC } from "react";
import { IconProps } from "./types";

export const Location: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C13.7657 3 15.5161 3.60067 16.8193 4.78223C18.1139 5.95589 19 7.73202 19 10.1553L18.9873 10.5107C18.859 12.3069 17.7885 14.3912 16.3545 16.3447L16.0908 16.6973C14.7554 18.4494 13.2081 19.9992 12 21L11.5 20.5713C10.3831 19.5824 9.06658 18.2158 7.90918 16.6973L7.64551 16.3447C6.21149 14.3912 5.141 12.3069 5.0127 10.5107L5 10.1553C5 7.88371 5.77858 6.18078 6.94238 5.00977L7.18066 4.78223C8.48395 3.60067 10.2343 3 12 3ZM12 4C10.4529 4 8.951 4.52755 7.85254 5.52344C6.77978 6.49605 6 7.99666 6 10.1553C6.00012 11.6935 6.94827 13.7056 8.45117 15.7529C9.56966 17.2766 10.8824 18.664 12 19.6738C13.1176 18.664 14.4303 17.2766 15.5488 15.7529C17.0517 13.7056 17.9999 11.6936 18 10.1553C18 7.99665 17.2203 6.49604 16.1475 5.52344C15.049 4.52754 13.5471 4 12 4Z"
      fill={fill}
    />
  </svg>
);
